/**
 * Fleet Performance Service Interface
 *
 * Service interface for fetching fleet performance data.
 * Currently backed by mock data; will be replaced by RTK Query endpoint.
 *
 * The interface is designed so that the Report_Output_View component
 * consumes data through this shared interface without direct dependency
 * on the data source. When the actual backend API replaces this mock
 * implementation, no changes to consuming components are required.
 *
 * Requirements: 4.3, 4.4
 */

import { fleetPerformanceMockData } from "./mockData";

/**
 * Fetches fleet performance data for the given parameters.
 *
 * @param {Object} params - Request parameters
 * @param {string} params.startTime - ISO 8601 start time for the report period
 * @param {string} params.endTime - ISO 8601 end time for the report period
 * @param {string[]} params.assetIds - Array of asset IDs to include in the report
 * @param {string} params.timezone - IANA timezone identifier (e.g., "Asia/Jakarta")
 * @returns {Promise<FleetPerformanceResponse>} Resolves with fleet performance data
 *   containing `top_vehicles` and `worst_vehicles` arrays
 */
export const getFleetPerformanceData = (params) => {
  // params: { startTime, endTime, assetIds, timezone }
  // Returns: Promise<FleetPerformanceResponse>
  return Promise.resolve(fleetPerformanceMockData);
};
